import _objectSpread from "/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
// Components
import VIcon from '../VIcon';
import VBtn from '../VBtn/VBtn'; // Types

import Vue from 'vue';
/* @vue/component */

export default Vue.extend({
  name: 'v-app-bar-nav-icon',
  functional: true,
  render: function render(h, _ref) {
    var slots = _ref.slots,
      listeners = _ref.listeners,
      props = _ref.props,
      data = _ref.data;
    var d = Object.assign(data, {
      staticClass: "v-app-bar__nav-icon ".concat(data.staticClass || '').trim(),
      props: _objectSpread(_objectSpread({}, props), {}, {
        icon: true
      }),
      on: listeners
    });
    var defaultSlot = slots().default;
    return h(VBtn, d, defaultSlot || [h(VIcon, '$menu')]);
  }
});